// Design Tokens - Shadows
// Use these tokens for all box-shadow values
// Based on FarLabs modern design system - Dark theme optimized

export const shadows = {
  // Named shadows - Dark theme optimized
  sm: '0 1px 2px 0 rgba(0, 0, 0, 0.3)',
  md: '0 4px 8px -2px rgba(0, 0, 0, 0.4), 0 2px 4px -2px rgba(0, 0, 0, 0.3)',
  lg: '0 10px 20px -5px rgba(0, 0, 0, 0.5), 0 4px 8px -4px rgba(0, 0, 0, 0.4)',
  xl: '0 20px 30px -10px rgba(0, 0, 0, 0.6), 0 10px 15px -8px rgba(0, 0, 0, 0.5)',
  '2xl': '0 30px 60px -15px rgba(0, 0, 0, 0.7)',
  '3xl': '0 40px 80px -20px rgba(0, 0, 0, 0.8)',
  none: 'none',

  // Inner shadow - Dark theme
  inner: 'inset 0 2px 4px 0 rgba(0, 0, 0, 0.3)',
  innerLg: 'inset 0 4px 8px 0 rgba(0, 0, 0, 0.4)',

  // Elevation system - Dark theme
  elevation: {
    low: '0 2px 4px rgba(0, 0, 0, 0.3), 0 1px 2px rgba(0, 0, 0, 0.4)',
    medium: '0 6px 12px rgba(0, 0, 0, 0.4), 0 4px 8px rgba(0, 0, 0, 0.5)',
    high: '0 12px 24px rgba(0, 0, 0, 0.5), 0 8px 12px rgba(0, 0, 0, 0.6)',
    highest: '0 20px 40px rgba(0, 0, 0, 0.6), 0 12px 20px rgba(0, 0, 0, 0.7)',
  },

  // Glow effects - Figma blue (#1e6ef6 = rgb(30, 110, 246))
  glow: {
    purple: {
      // Legacy name - now uses Figma blue
      sm: '0 0 12px rgba(30, 110, 246, 0.4)',
      md: '0 0 24px rgba(30, 110, 246, 0.5)',
      lg: '0 0 36px rgba(30, 110, 246, 0.6)',
      xl: '0 0 48px rgba(30, 110, 246, 0.7)',
    },
    magenta: {
      // Legacy name - now uses Figma blue
      sm: '0 0 12px rgba(30, 110, 246, 0.4)',
      md: '0 0 24px rgba(30, 110, 246, 0.5)',
      lg: '0 0 36px rgba(30, 110, 246, 0.6)',
      xl: '0 0 48px rgba(30, 110, 246, 0.7)',
    },
    violet: {
      // Legacy name - now uses Figma blue
      sm: '0 0 12px rgba(30, 110, 246, 0.4)',
      md: '0 0 24px rgba(30, 110, 246, 0.5)',
      lg: '0 0 36px rgba(30, 110, 246, 0.6)',
    },
    blue: {
      sm: '0 0 12px rgba(59, 130, 246, 0.4)',
      md: '0 0 24px rgba(59, 130, 246, 0.5)',
      lg: '0 0 36px rgba(59, 130, 246, 0.6)',
    },
    cyan: {
      sm: '0 0 12px rgba(6, 182, 212, 0.4)',
      md: '0 0 24px rgba(6, 182, 212, 0.5)',
      lg: '0 0 36px rgba(6, 182, 212, 0.6)',
    },
    green: {
      sm: '0 0 12px rgba(16, 185, 129, 0.4)',      // Emerald green glow
      md: '0 0 24px rgba(16, 185, 129, 0.5)',
      lg: '0 0 36px rgba(16, 185, 129, 0.6)',
      xl: '0 0 48px rgba(16, 185, 129, 0.7)',
    },
    orange: {
      sm: '0 0 12px rgba(245, 158, 11, 0.4)',      // Amber/orange glow
      md: '0 0 24px rgba(245, 158, 11, 0.5)',
      lg: '0 0 36px rgba(245, 158, 11, 0.6)',
      xl: '0 0 48px rgba(245, 158, 11, 0.7)',
    },
    red: {
      sm: '0 0 12px rgba(239, 68, 68, 0.4)',
      md: '0 0 24px rgba(239, 68, 68, 0.5)',
      lg: '0 0 36px rgba(239, 68, 68, 0.6)',
    },
  },

  // Glassmorphism effects
  glass: {
    sm: '0 4px 6px rgba(0, 0, 0, 0.1), 0 0 1px rgba(255, 255, 255, 0.1)',
    md: '0 8px 16px rgba(0, 0, 0, 0.2), 0 0 1px rgba(255, 255, 255, 0.1)',
    lg: '0 16px 32px rgba(0, 0, 0, 0.3), 0 0 1px rgba(255, 255, 255, 0.15)',
  },

  // Combined glow + shadow for interactive elements (matches Connect GPU button)
  interactive: {
    purple: '0 4px 14px rgba(0, 0, 0, 0.4), 0 0 24px rgba(30, 110, 246, 0.4)',
    purpleHover: '0 6px 20px rgba(0, 0, 0, 0.5), 0 0 32px rgba(30, 110, 246, 0.6)',
    purpleActive: '0 2px 8px rgba(0, 0, 0, 0.6), 0 0 16px rgba(30, 110, 246, 0.5)',
    magenta: '0 4px 14px rgba(0, 0, 0, 0.4), 0 0 24px rgba(30, 110, 246, 0.4)',
    magentaHover: '0 6px 20px rgba(0, 0, 0, 0.5), 0 0 32px rgba(30, 110, 246, 0.6)',
  },
} as const;
